import * as AuthApi from "../pages/Authentication/api/AuthRequst.js";

export const logIn = (formData) => async (dispatch) => {
    dispatch({ type: "AUTH_START" });
    try {
        const { data } = await AuthApi.logIn(formData);
        dispatch({ type: "AUTH_SUCCESS", data: data });
        return { success: true, data: data };  // Return success result
    } catch (error) {
        console.log(error);
        dispatch({ type: "AUTH_FAIL" });
        return { success: false, error: error };  // Return failure result
    }
};

export const setAccessPermissions = (permissions) => ({
    type: 'SET_ACCESS_PERMISSIONS',
    payload: permissions,
});

export const setAccessPages = (pages) => ({
    type: 'SET_ACCESS_PAGES',
    payload: pages,
});

export const refreshSessionAuthData = () => async (dispatch, getState) => {
    try {
        const stateAuthData = getState()?.authReducer?.authData;
        const localProfile = JSON.parse(localStorage.getItem("profile") || "null");
        const localUser = JSON.parse(localStorage.getItem("user") || "null");
        const currentAuthData = stateAuthData || localProfile;
        const sessionID = currentAuthData?.sessionID || localStorage.getItem("session-id");
        const userId = currentAuthData?.userData?._id || localUser?._id;

        if (!sessionID || !userId) {
            return { success: false, message: "Missing session or user id." };
        }

        const userResponse = await AuthApi.getCurrentSessionUser(sessionID, userId);
        if (!userResponse?.data?.status || !userResponse?.data?.data?.length) {
            return { success: false, message: "Unable to refresh current user." };
        }

        const latestUserData = userResponse.data.data[0];
        let latestRoleDetails = latestUserData?.role_details;

        if (latestUserData?.role_id) {
            const roleResponse = await AuthApi.getRoleDetails(sessionID, latestUserData.role_id);
            if (roleResponse?.data?.status && roleResponse?.data?.data?.length) {
                latestRoleDetails = roleResponse.data.data[0];
            }
        }

        const refreshedUser = {
            ...(currentAuthData?.userData || {}),
            ...latestUserData,
            role_details: latestRoleDetails || currentAuthData?.userData?.role_details,
        };
        const refreshedAuthData = {
            ...(currentAuthData || {}),
            status: true,
            sessionID,
            userData: refreshedUser,
        };

        localStorage.setItem("user", JSON.stringify(refreshedUser));
        dispatch({ type: "AUTH_SUCCESS", data: refreshedAuthData });
        return { success: true, data: refreshedAuthData };
    } catch (error) {
        console.log("refreshSessionAuthData error", error);
        return { success: false, error };
    }
};

